import React, { lazy, useState, Suspense, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { AppDispatch } from "../../app/store";
import { selectPlayer } from "../../features/player/playerSlice";
import {
  selectTheme,
  setMode,
  showLoginPopup,
  ThemeMode,
} from "../../features/theme/themeSlice";

const Kiosk = () => {
  const player = useAppSelector(selectPlayer);
  const theme = useAppSelector(selectTheme);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  //  const location = useLocation();

  useEffect(() => {
    if (player.logged && player.groups.indexOf("Players") > -1) {
      navigate("/404")
    }
    else {
      dispatch(setMode(ThemeMode.KIOSK));
      if (!player.logged) {
        dispatch(showLoginPopup(true));
      }
      localStorage.setItem("kiosk", "true");
      navigate("/");
    }
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Kiosk PGP</title>
      </Helmet>
    </div>
  );
};

export default Kiosk;
